import { createPolkadotChains } from '../utils/polkadotChain'

export const blankApiKeyPolkadotChains = createPolkadotChains({})
